import React, { useState, useEffect, useRef } from "react";
import "./ChatScreen.scss";
import { BsSearch, BsPlusCircleFill } from "react-icons/bs";
import { FaPaperPlane } from "react-icons/fa";
import { postDetails } from "../../services/http/http.service";
import APIList from "../../utils/constants/APIList";
import { useNavigate } from "react-router-dom";
import { useAppDispatch } from "../../store/storeRequests";
import { hideLoader, showLoader } from "../../store/Loader/loader.slice";
import { Modal, Button } from "react-bootstrap";
import { FaTrashAlt } from "react-icons/fa";
import { Trash3Fill } from "react-bootstrap-icons";
import profileIcon from "../../assets/default-profile.png";
import { SlArrowRight } from "react-icons/sl";
import { SlArrowLeft } from "react-icons/sl";

interface Contact {
  recieverId: number;
  is_seen: 0 | 1;
  id: number;
  name: string;
  lastMessage: string;
  lastMessageTime: string;
  profile: string | null;
}

interface Message {
  isOwn: boolean;
  id: number;
  sender: string;
  content: string;
  timestamp: string;
  senderId?: number;
}

const ChatScreen: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const [contacts, setContacts] = useState<Contact[]>([]);
  const [messages, setMessages] = useState<Message[]>([]);
  const [selectedContactId, setSelectedContactId] = useState<number | null>(
    null
  );
  const [newMessage, setNewMessage] = useState<string>("");
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);
  const [selectedContact, setSelectedContact] = useState<Contact | null>(null);
  const [searchQuery, setSearchQuery] = useState<string>("");

  const [showModal, setShowModal] = useState<boolean>(false);
  const [availableContacts, setAvailableContacts] = useState<Contact[]>([]);
  const [modalSearchQuery, setModalSearchQuery] = useState<string>("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const modalBodyRef = useRef<HTMLDivElement | null>(null);  const messagesEndRef = useRef<HTMLDivElement>(null);
  const [contactsPerPage] = useState(10); // Set the number of contacts to show per page
  const [currentPage, setCurrentPage] = useState(1);
  const filteredContacts = contacts.filter((contact) =>
    contact.name.toLowerCase().trim().includes(searchQuery.toLowerCase().trim())
  );

  // useEffect(() => {
  //   const fetchContacts = async () => {
  //     try {
  //       dispatch(showLoader("Loading Data..."));
  //       const response = await postDetails(APIList.GET_CHAT_HISTORY, {});
  //       const data = await response.data;
  //       const mappedContacts: Contact[] = data.map((item: any) => ({
  //         id: item.isOwn === 0 ? item.senderId : item.recieverId,
  //         name: item.name,
  //         is_seen: item.is_seen,
  //         recieverId: item.recieverId,
  //         lastMessage: item.message,
  //         lastMessageTime: new Date(item.modified).toLocaleTimeString([], {
  //           hour: "2-digit",
  //           minute: "2-digit",
  //         }),
  //         profile: item.profile ?? null,
  //       }));

  //       setContacts(mappedContacts);
  //       console.log(mappedContacts);
  //     } catch (error: any) {
  //       setError(error.message);
  //     } finally {
  //       setLoading(false);
  //       dispatch(hideLoader());
  //     }
  //   };

  //   fetchContacts();
  // }, []);

  const fetchContacts = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_CHAT_HISTORY, {});
      const data = await response.data;
      const mappedContacts: Contact[] = data.map((item: any) => ({
        id: item.isOwn === 0 ? item.senderId : item.recieverId,
        name: item.name,
        is_seen: item.is_seen,
        recieverId: item.recieverId,
        lastMessage: item.message,
        lastMessageTime: new Date(item.modified).toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
        }),
        profile: item.profile ?? null,
      }));
  
      setContacts(mappedContacts);
      console.log(mappedContacts);
    } catch (error: any) {
      setError(error.message);
    } finally {
      setLoading(false);
      dispatch(hideLoader());
    }
  };
  
  useEffect(() => {
    // Call fetchContacts within useEffect
    fetchContacts();
  }, []);
  useEffect(() => {
    scrollToBottom();
  }, [messages]);


  useEffect(() => {
    if (modalBodyRef.current) {
      modalBodyRef.current.scrollTop = 0;
    }
  }, [modalSearchQuery]);
  const fetchMessages = async (contactId: number) => {
    if (!contactId) return;

    try {
      const response = await postDetails(APIList.GET_CHAT_BY_ID, {
        id: contactId,
      });
      const data = await response.data;

      if (data && data.length > 0) {
        const mappedMessages: Message[] = data.map((item: any) => ({
          id: item.id,
          sender: item.sender,
          content: item.message,
          senderId: item.senderId,
          timestamp: new Date(item.timestamp).toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          isOwn: item.isOwn === 1,
        }));

        setMessages(mappedMessages);
      } else {
        setMessages([]);
      }
    } catch (error: any) {
      setError(error.message);
    }
  };

  const fetchAvailableContacts = async () => {
    try {
      dispatch(showLoader("Loading Data..."));
      const response = await postDetails(APIList.GET_ALL_PEOPLE, {});
      const data = await response.data;
      const mappedAvailableContacts: Contact[] = data.map((item: any) => ({
        id: item.id,
        name: `${item.first_name} ${item.last_name}`,
        profile: item.profile ?? null,
        is_seen: 1,
        recieverId: item.id,
        lastMessage: "",
        lastMessageTime: "",
      }));
      setAvailableContacts(mappedAvailableContacts);
    } catch (error: any) {
      console.log(error.message);
    } finally {
      dispatch(hideLoader());
    }
  };

  const handleSendMessage = async () => {
    if (newMessage.trim() === "" || selectedContactId === null) return;

    try {
      const response = await postDetails(APIList.SEND_MESSAGE, {
        recieverId: selectedContactId,
        message: newMessage,
      });
      if (response) {
        const newSentMessage: Message = {
          id: Date.now(),
          sender: "You",
          content: newMessage,
          senderId: 1,
          timestamp: new Date().toLocaleTimeString([], {
            hour: "2-digit",
            minute: "2-digit",
          }),
          isOwn: true,
        };

        setMessages((prevMessages) => [...prevMessages, newSentMessage]);
        setNewMessage("");

        fetchMessages(selectedContactId);
         fetchContacts();

      }
    } catch (error: any) {
      console.log(error.message);
    }
  };
  

  const handleDeleteChat = async () => {
    if (selectedContactId === null) return;

    try {
      dispatch(showLoader("Deleting chat..."));
      const response = await postDetails(APIList.DELETE_CHAT_BY_ID, {
        id: selectedContactId,
      });

      if (response) {
        setContacts((prevContacts) =>
          prevContacts.filter((contact) => contact.id !== selectedContactId)
        );

        setMessages([]);
        setSelectedContactId(null);
        setSelectedContact(null);
        setShowDeleteModal(false);
        // console.log("Chat deleted successfully");
      }
    } catch (error: any) {
      console.error("Error deleting chat:", error.message);
    } finally {
      setTimeout(() => dispatch(hideLoader()), 3000);
    }
  };

  const scrollToBottom = () => {
    if (messagesEndRef.current) {
      messagesEndRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  const handleKeyPress = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === "Enter") {
      handleSendMessage();
    }
  };

  const handleNewChatClick = () => {
    fetchAvailableContacts();
    setShowModal(true);
    // setSelectedContactId(contact.id);
    // const temp: Contact[] = contacts.map((item) => {
    //   if (contact.id === item.id) {
    //     return { ...item, is_seen: 1 };
    //   }
    //   return item;
    // });
    // setContacts(temp);
    // setSearchQuery("");
  
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setModalSearchQuery("");
  };

  const handleStartNewChat = (contact: Contact) => {
    setSelectedContactId(contact.id);
    setSelectedContact(contact);

    setMessages([]);

    setModalSearchQuery("");
    // setCurrentPage(1);
    setShowModal(false);

    fetchMessages(contact.id);
  };
  const handleSearchChange = (e:any) => {
    setModalSearchQuery(e.target.value);
    setCurrentPage(1); // Reset to first page on search
  };
  // const filteredModalContacts = availableContacts.filter((contact) =>
  //   contact.name
  //     .toLowerCase()
  //     .trim()
  //     .includes(modalSearchQuery.toLowerCase().trim())
  // );
  const filteredModalContacts = availableContacts.filter((contact) =>
    contact.name.toLowerCase().trim().includes(modalSearchQuery.toLowerCase().trim())
  );
  const indexOfLastContact = currentPage * contactsPerPage;
const indexOfFirstContact = indexOfLastContact - contactsPerPage;
const currentContacts = filteredModalContacts.slice(indexOfFirstContact, indexOfLastContact);

const totalPages = Math.ceil(filteredModalContacts.length / contactsPerPage);

// Pagination button handlers
const handleNextPage = () => {
  if (currentPage < totalPages) {
    setCurrentPage(currentPage + 1);
  }
};

const handlePrevPage = () => {
  if (currentPage > 1) {
    setCurrentPage(currentPage - 1);
  }
};

  const handleCloseDeleteModal = () => setShowDeleteModal(false);

  const selectContact = (contactId: number | null) => {
    if (contactId !== null) {
      fetchMessages(contactId);

      const contact = contacts.find((contact) => contact.id === contactId);
      setSelectedContact(contact || null);

      setNewMessage("");
    }
  };

  const handleChatClick = (contact: Contact) => {
    setSelectedContactId(contact.id);
    selectContact(contact.id);

    const updatedContacts: Contact[] = contacts.map((item) => {
      if (contact.id === item.id) {
        return { ...item, is_seen: 1 };
      }
      return item;
    });

    setContacts(updatedContacts);
    setSearchQuery("");
  };

  return (
    <div className="chat-screen">
      <div className="contact-sidebar">
        <div className="search-bar">
          <BsSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search or start new chat"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
          />
        </div>
        {loading ? (
          <div className="loading">Loading contacts...</div>
        ) : error ? (
          <div className="error">{error}</div>
        ) : (
          <>
            <ul className="contact-list">
              {searchQuery && filteredContacts.length === 0 ? (
                <li className="no-contacts-found">No contacts found</li>
              ) : (
                filteredContacts.map((contact) => (
                  <li
                    key={contact.id}
                    onClick={() => handleChatClick(contact)}
                    className={`contact-item ${
                      contact.recieverId === 1 && contact.is_seen === 0
                        ? "unread"
                        : ""
                    } ${selectedContactId === contact.id ? "active" : ""}`}
                  >
                    <div className="contact-pic">
                      <img
                        src={contact.profile ? contact.profile : profileIcon}
                        alt={contact.name}
                      />
                    </div>
                    <div className="contact-info">
                      <div className="contact-name">{contact.name}</div>
                      <div className="last-message">{contact.lastMessage}</div>
                    </div>
                  </li>
                ))
              )}
            </ul>
            <div className="new-chat-button" onClick={handleNewChatClick}>
              <BsPlusCircleFill className="plus-icon" />
            </div>
          </>
        )}
      </div>

      <div className="chat-window">
        {selectedContact ? (
          <>
            <div className="chat-header">
              <div className="contact-pic">
                <img
                  src={selectedContact.profile || profileIcon}
                  alt={selectedContact.name}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>
              <div className="contact-name">{selectedContact.name}</div>

              {/* <button
                className="hr-delete-btn"
                style={{
                  cursor: "pointer",
                  marginLeft: "auto",
                }}
                onClick={() => setShowDeleteModal(true)}
              >
              <Trash3Fill />  Delete 
              </button> */}
                {messages.length > 0 && (
      <button
        className="hr-delete-btn"
        style={{
          cursor: "pointer",
          marginLeft: "auto",
        }}
        onClick={() => setShowDeleteModal(true)}
      >
        <Trash3Fill /> Delete
      </button>
    )}
            </div>

            <div className="messages">
              {messages.map((message) => (
                <div
                  key={message.id}
                  className={`message ${
                    message.senderId === 1 ? "sent" : "received"
                  }`}
                >
                  <div className="content">{message.content}</div>
                </div>
              ))}
              <div ref={messagesEndRef} />
            </div>
            <div className="message-input">
              <input
                type="text"
                placeholder="Type a message"
                value={newMessage}
                onChange={(e) => setNewMessage(e.target.value)}
                onKeyPress={handleKeyPress}
              />
              <FaPaperPlane className="icon send" onClick={handleSendMessage} />
            </div>
          </>
        ) : (
          <div className="chat-placeholder">
            <p>Select a contact to start chatting</p>
          </div>
        )}
      </div>
{/* 
      <Modal
        show={showModal}
        onHide={handleCloseModal}
        centered
        dialogClassName="custom-modal"
        onClick={(e: { stopPropagation: () => any }) => e.stopPropagation()}
      >
        <Modal.Header closeButton>
          <Modal.Title>Start New Chat</Modal.Title>
        </Modal.Header>

        <Modal.Body
          className="chatscreen-modal-body"
          style={{ height: "500px", overflowY: "auto", padding: "0" }}
          ref={modalBodyRef}
        >
          <div
            className="search-bar"
            style={{
              display: "flex",
              alignItems: "center",
              padding: "10px 15px",
              position: "sticky",
              top: "0",
              background: "#fff",
              zIndex: "1",
              borderBottom: "1px solid #ddd",
              margin: "0",
            }}
          >
            <BsSearch className="search-icon" style={{ marginRight: "10px" }} />
            <input
              type="text"
              placeholder="Search contacts"
              value={modalSearchQuery}
              onChange={(e) => setModalSearchQuery(e.target.value)}
              style={{
                flex: "1",
                padding: "8px",
                borderRadius: "5px",
                border: "1px solid #ddd",
                outline: "none",
              }}
            />
          </div>

          <ul
            className="available-contacts-list"
            style={{ padding: "0", margin: "0" }}
          >
            {modalSearchQuery && filteredModalContacts.length === 0 ? (
              <li className="no-contacts-found">No contacts found</li>
            ) : (
              filteredModalContacts.map((contact) => (
                <li
                  key={contact.id}
                  onClick={() => handleStartNewChat(contact)}
                  className="available-contact-item"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    padding: "10px",
                    cursor: "pointer",
                    borderBottom: "1px solid #ddd",
                  }}
                >
                  <div className="contact-pic" style={{ marginRight: "10px" }}>
                    <img
                      src={contact.profile || profileIcon}
                      alt={contact.name}
                      style={{
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                      }}
                    />
                  </div>

                  <div className="contact-info">
                    <div
                      className="contact-name"
                      style={{ fontWeight: "bold" }}
                    >
                      {contact.name}
                    </div>
                  </div>
                </li>
              ))
            )}
          </ul>
        </Modal.Body>

        <Modal.Footer style={{ justifyContent: "space-between" }}>
          <Button variant="danger" onClick={handleCloseModal}>
            Close
          </Button>
        </Modal.Footer>
      </Modal> */}
      
      <Modal 
    show={showModal}
    onHide={handleCloseModal}
    centered
    dialogClassName="custom-modal"
    onClick={(e:any) => e.stopPropagation()}
  >
    <Modal.Header closeButton>
      <Modal.Title>Start New Chat</Modal.Title>
    </Modal.Header>

    <Modal.Body
      className="chatscreen-modal-body"
      style={{ height: "500px", overflowY: "auto", padding: "0" }}
      ref={modalBodyRef}
    >
      <div className="search-bar" style={{
        display: "flex",
        alignItems: "center",
        padding: "10px 15px",
        position: "sticky",
        top: "0",
        background: "#fff",
        zIndex: "1",
        borderBottom: "1px solid #ddd",
        margin: "0",
      }}>
        <BsSearch className="search-icon" style={{ marginRight: "10px" }} />
        <input
          type="text"
          placeholder="Search contacts"
          value={modalSearchQuery}
          // value={searchQuery}
        onChange={handleSearchChange}
          style={{
            flex: "1",
            padding: "8px",
            borderRadius: "5px",
            border: "1px solid #ddd",
            outline: "none",
          }}
        />
      </div>

      <ul className="available-contacts-list" style={{ padding: "0", margin: "0" }}>
        {modalSearchQuery && filteredModalContacts.length === 0 ? (
          <li className="no-contacts-found">No contacts found</li>
        ) : (
          currentContacts.map((contact) => (
            <li
              key={contact.id}
              onClick={() => handleStartNewChat(contact)}
              className="available-contact-item"
              style={{
                display: "flex",
                alignItems: "center",
                padding: "10px",
                cursor: "pointer",
                borderBottom: "1px solid #ddd",
              }}
            >
              <div className="contact-pic" style={{ marginRight: "10px" }}>
                <img
                  src={contact.profile || profileIcon}
                  alt={contact.name}
                  style={{
                    width: "40px",
                    height: "40px",
                    borderRadius: "50%",
                  }}
                />
              </div>

              <div className="contact-info">
                <div className="contact-name" style={{ fontWeight: "bold" }}>
                  {contact.name}
                </div>
              </div>
            </li>
          ))
        )}
      </ul>
    </Modal.Body>

    <Modal.Footer style={{ justifyContent: "space-between" }}>
      <button className="previous-button" onClick={handlePrevPage} disabled={currentPage === 1}>
        {/* Previous */}
        <SlArrowLeft />
      </button>
      <span>
        Page {currentPage} of {totalPages}
      </span>
      <button  className="previous-button" onClick={handleNextPage} disabled={currentPage === totalPages}>
        {/* Next */}
        <SlArrowRight />
      </button>
      <Button variant="danger" onClick={handleCloseModal}>
        Close
      </Button>
    </Modal.Footer>
  </Modal>
      <Modal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        centered
        className="deleteAll-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to delete?</p>
          <Button className="btn-danger" onClick={handleDeleteChat}>
            Delete
          </Button>
        
          <Button
            className="btn-warning text-white"
            onClick={handleCloseDeleteModal}
          >
            Cancel
          </Button>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default ChatScreen;